import { BaseEntity } from 'yt-ng-framework';

export class  OsnovZaPlacenoOdsustvo extends BaseEntity {
    constructor(){
        super();
    }
    Naziv: string = null;
    min_broj_dana: number = null;

    Deserialize(input: any) {
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.min_broj_dana = input.min_broj_dana;
        return this;
    }

    Serialize(input: OsnovZaPlacenoOdsustvo) {
        return input;
    }
}
